import { AutocompleteSource } from "@algolia/autocomplete-core";
import { getAlgoliaResults } from "@algolia/autocomplete-js";
import { isEmpty } from "lodash-es";

import { isDefined } from "@utils/helpers";

import { AlgoliaClient } from "@services/algolia/types/client.types";
import { AlgoliaSearchResult } from "@services/algolia/types/search.types";

import {
    PRODUCTS_SOURCE_ID,
    PRODUCT_COUNT,
} from "@components/Search/SearchAutocomplete/autoCompleteConstants";
import { ProductsSourceType } from "@components/Search/SearchAutocomplete/autocompleteTypes";
import transformQueryForMultiSku from "@components/Search/SearchAutocomplete/helpers/multiSku.helpers";

import { ProductAlgoliaModel } from "lib/@types/service/product/algolia/product.algolia.model";

export const productsSource = (
    indexName: string,
    searchClient?: AlgoliaClient,
    initialProducts?: Array<ProductAlgoliaModel>,
): AutocompleteSource<ProductsSourceType> => ({
    sourceId: PRODUCTS_SOURCE_ID,
    // @ts-ignore
    getItems({ setContext, state, query }) {
        if (!query && isDefined(initialProducts) && !isEmpty(initialProducts)) {
            const context = state.context;
            context.nbProductHits = initialProducts.length;
            setContext(context);

            return initialProducts;
        }

        return isDefined(searchClient)
            ? getAlgoliaResults<ProductsSourceType>({
                  searchClient: searchClient,
                  queries: [
                      {
                          indexName: indexName,
                          params: {
                              query: query,
                              hitsPerPage: PRODUCT_COUNT,
                              clickAnalytics: true,
                          },
                      },
                  ].map(transformQueryForMultiSku),
                  transformResponse({ results }) {
                      const productsResult =
                          results[0] as AlgoliaSearchResult<ProductsSourceType>;

                      const context = state.context;
                      context.nbProductHits = productsResult.nbHits;
                      setContext(context);

                      return productsResult.hits;
                  },
              })
            : [];
    },
});
